module.exports = __webpack_public_path__ + "img/8ceefb8ea93b87f3c38f58ec9fe1f49f.png";